import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Dashboard.css';
import { auth } from '../firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { db } from '../firebase';
import { doc, collection, addDoc, getDoc, where, query, getDocs } from 'firebase/firestore';
import CreateAppointmentForm from "../components/CreateAppointmentForm";
import MainSection from "../components/MainSection";
import SelectAppointmentForPrescription from '../components/SelectAppointmentForPrescription';
import CreatePrescriptionForm from '../components/CreatePrescriptionForm';
import AddPatientForm from '../components/AddPatientForm';
import AddUserForm from '../components/AddUser';
import PatientList from '../components/PatientList';
import DoctorList from '../components/DoctorList';
import AppointmentList from '../components/AppointmentList';
import UsersList from '../components/TenantUsers';
import { useTenant } from '../context/TenantContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPills, faSignOut, faUser, faUsers, faUserPlus, faUserMd, faCalendar, faCreditCard, faList, faCircleDot, faUserCircle, faPhone } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import UserInfo from '../components/UserInfo';
import FetchPatientHistory from '../components/FetchPatientHistory';
import Loader from '../components/Loader';
import ContactSupport from '../components/ContactSupport';


library.add(fab, faPhone, faPills, faSignOut, faUser, faUsers, faUserPlus, faUserMd, faCalendar, faCreditCard, faList, faCircleDot, faUserCircle);

function Dashboard() {
  const navigate = useNavigate();
  const [user, setUser, setStore] = useState();
  const [tenantName, setTenantName] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [patientData, setPatientData] = useState({
    name: '',
    age: '',
    gender: '',
    email: '',
    phoneNumber: '',
  });
  const [userData, setUserData] = useState();
  const [activeSection, setActiveSection] = useState("MainSection");
  /*const [sumSection, setSumSection] = useState("ShortSection");*/
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const { tenantId, setTenantId, setRole } = useTenant();
  const [loading, setLoading] = useState(true);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);


  useEffect(() => {
    // This listener handles user authentication state changes
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser); // Set the basic user object from auth

        // Now, fetch the detailed user profile from Firestore
        setLoading(true);
        try {
          // Use the query to find the user document that contains this user's UID
          const q = query(collection(db, 'users'), where('uids', 'array-contains', currentUser.uid));
          const querySnapshot = await getDocs(q);

          if (!querySnapshot.empty) {
            const userProfileData = querySnapshot.docs[0].data();
            setUserData(userProfileData); // *** THIS IS THE FIX ***

            // Fetch the tenant document to get the tenantName
            if (userProfileData.tenantId) {
              try {
                const tenantDocRef = doc(db, 'tenants', userProfileData.tenantId);
                const tenantDocSnap = await getDoc(tenantDocRef);
                if (tenantDocSnap.exists()) {
                  setTenantName(tenantDocSnap.data().tenantName || 'Your Store');
                } else {
                  console.warn('Tenant document not found');
                }
              } catch (tenantErr) {
                console.error('Error fetching tenant:', tenantErr);
              }
            }

          } else {
            console.warn('No user document found in Firestore for this UID.');
          }
        } catch (error) {
          console.error("Error fetching user data from Firestore: ", error);
        } finally {
          setLoading(false);
        }

      } else {
        // Handle user being logged out
        setUser(null);
        setUserData(null);
        navigate('/login');
      }
    });

    // Cleanup subscription on component unmount
    return () => unsubscribe();
  }, [navigate]); // Add navigate to dependency array

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setTenantId(null);
      setRole(null);
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const handleChange = (e) => {
    setPatientData({ ...patientData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Add patient data to "patients" collection
      await addDoc(collection(db, 'patients'), patientData);

      console.log('Patient submitted:', patientData);
      alert('Patient added successfully!');

      // Reset form and close modal
      setPatientData({
        name: '',
        age: '',
        gender: '',
        email: '',
        phoneNumber: '',
      });
      setShowForm(false);
    } catch (error) {
      console.error('Error adding patient:', error);
      alert('Failed to add patient. Try again.');
    }
  };

  const displayUserInfo = (user) => {
    setConfirmOpen(true);
  };
  const displayContactmsg = (user) => {
    setContactOpen(true);
  }

  /*const rendershortcutbtns = () => {
    switch (sumSection) {
      case "summaryshow": return <sumtest />;
        default: return <sumtest />
    }
  };*/

  const renderSection = () => {
    switch (activeSection) {
      case "appointment": return <CreateAppointmentForm />;
      case 'patients': return <PatientList />;
      case 'doctors': return <DoctorList />;
      case 'appointments': return <AppointmentList />;
      case "addPatient": return <AddPatientForm />;
      case "fetchHistory": return <FetchPatientHistory />;
      case 'AddUserForm': return <AddUserForm />;
      case 'UsersList': return <UsersList />;
      default: return <MainSection />;
      case "prescription":
        return selectedAppointment
          ? <CreatePrescriptionForm appointment={selectedAppointment} onBack={() => setSelectedAppointment(null)} />
          : <SelectAppointmentForPrescription onSelect={setSelectedAppointment} />;
    }
  };


  return (
    <div className="dashboard-container">
      {/* Header / Banner */}
      <header className="dashboard-header">
        <div className="header-left">
          <h1><FontAwesomeIcon icon="fa-pills" className="dashboard-header-icon" onClick={() => navigate('/')} />Dashboard</h1>
        </div>
        <div className="header-right">
          <span>
            { }
          </span>
          <div className="header-greeting-container">
            <div className="plan-status">
              <span className="online-dot"></span>
              <span className="plan-text">{userData?.plan || 'Loading...'} Plan</span>
            </div>
            <span className="user-info">
              {user ? `Hello, ${user?.name || user?.email}` : 'Loading...'}
            </span>
          </div>
          <button className="header-btn" onClick={displayUserInfo}>User Info <FontAwesomeIcon icon="fa-user" className="unauth-header-icon" /></button>
          <button className="header-btn logout" onClick={handleLogout}>Log Out <FontAwesomeIcon icon="fa-sign-out" className="unauth-header-icon" /></button>

        </div>
      </header>

      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-store-name">
          <h3>{tenantName || 'Loading...'}</h3>
        </div>
        <nav className="sidebar-nav">
          <button onClick={() => setActiveSection('mainsection')}><FontAwesomeIcon icon="fa-circle-dot" className="sidebar-icon" /> Overview</button>
          <button onClick={() => setActiveSection('patients')}><FontAwesomeIcon icon="fa-user-plus" className="sidebar-icon" /> Patients</button>
          <button onClick={() => setActiveSection('appointments')}><FontAwesomeIcon icon="fa-calendar" className="sidebar-icon" /> Appointments</button>
          <button onClick={() => setActiveSection('mainsection')}><FontAwesomeIcon icon="fa-list" className="sidebar-icon" /> Prescriptions</button>
          <button><FontAwesomeIcon icon="fa-credit-card" className="sidebar-icon" /> Receipts</button>
          <button onClick={() => setActiveSection('doctors')}><FontAwesomeIcon icon="fa-user-md" className="sidebar-icon" /> Doctors</button>
          <button onClick={() => setActiveSection('UsersList')}><FontAwesomeIcon icon="fa-users" className="sidebar-icon" /> Users</button>
          <button onClick={() => navigate("/accountbilling")}><FontAwesomeIcon icon="fa-user-circle" className="sidebar-icon" /> Account & Billing</button>
          <button onClick={() => navigate("/checkout")}><FontAwesomeIcon icon="fa-user-circle" className="sidebar-icon" /> Upgrade Plan</button>
        </nav>

      </aside>

      <button className="sidebar-support-btn" onClick={displayContactmsg}><FontAwesomeIcon icon="fa-phone" className="sidebar-icon" /> Contact Support</button>

      {/* Main content area */}
      <main className="main-content">
        {/* Shortcut Buttons */}
        <section className="shortcuts">
          <button className="shortcut-btn" onClick={() => setActiveSection("addPatient")}>Add Patient</button>
          <button className="shortcut-btn" onClick={() => setActiveSection("appointment")}>Create Appointment</button>
          <button className="shortcut-btn" onClick={() => setActiveSection("prescription")}>Create Prescription</button>
          <button className="shortcut-btn" onClick={() => setActiveSection("AddUserForm")}>Add User</button>
          <button className="shortcut-btn" onClick={() => setActiveSection("fetchHistory")}>Fetch History</button>
        </section>


        {/* Main Dashboard Section */}
        <div className="current-section">
          {renderSection()}
        </div>

      </main>

      <UserInfo
        open={confirmOpen}
        title="User Info"
        username={userData?.name}
        userphone={userData?.phone}
        useremail={userData?.email}
        userrole={userData?.role}
        plan={userData?.plan}
        onCancel={() => setConfirmOpen(false)}
      />
      <ContactSupport
        contactOpen={contactOpen}
        title="Contact Support"
        username={userData?.name}
        useremail={userData?.email}
        onCancel={() => setContactOpen(false)}
      />
    </div>
  );
}

export default Dashboard;
